export default {
    "hello":"hello hindi"
}